import React, { Component, useEffect, useState } from 'react'
import { Bar } from 'react-chartjs-2'
import WTypography from '../../../../Components/whiteTypography'

const optionsbar = {
  indexAxis: 'x',
  legend: { 
    display: false, 
    },
  scales: {
    x: {
      ticks: {
        color: 'white', // Couleur du texte pour les axes X
      },
      grid: {
        color: 'rgba(255,255,255,0.1)', // Optionnel: couleur des lignes de grille pour l'axe X
      },
    },
    y: {
      ticks: {
        color: 'white', // Couleur du texte pour les axes Y
      },
      grid: {
        color: 'rgba(255,255,255,0.1)', // Optionnel: couleur des lignes de grille pour l'axe Y
      },
    },
  },
  plugins: {
    datalabels: {
      display: false,
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem) {
          return tooltipItem.yLabel
        },
        title: () => null,
      },
    },
  },
}

function GEmissionBarChart({ reports }) {
  const [data, setRevData] = useState({
    labels: ['2020', '2021', '2022'],
    datasets: [
      {
        label: '1',
        data: [5, 6, 2],
        backgroundColor: ['white'],
        borderWidth: 1,
      },
      {
        label: '2',
        data: [6, 3, 4],
        backgroundColor: ['gray'],
       
        borderWidth: 1,
      },
      {
        label: '3',
        data: [9, 6, 7],
        backgroundColor: ['yellow'],
       
        borderWidth: 1,
      },
      {
        label: '4',
        data: [9, 6, 7],
        backgroundColor: ['green'],
        
        borderWidth: 1,
      },
    ],
  })
  useEffect(() => {
    let reports_data = [...reports]
    reports_data.sort((a, b) => (a.date > b.date ? 1 : -1))
   
    let labels = []
    let groupName = ['Logement', 'Transport', 'Shopping', 'Alimentation']
    let color = ['#a7c1f5', '#668bcf', '#3d6dad', '#274889']
    let Logement = []
    let Transport = []
    let Shopping = []
    let Alimentation = []
    reports_data &&
      reports_data.map((item, i) => {
        labels.push(item.date)
      })
    labels &&
      labels.forEach((val, idx) => {
      
        Logement.push(reports_data[idx].emission_logement)
        Transport.push(reports_data[idx].emission_transport)
        Shopping.push(reports_data[idx].emission_shopping)
        Alimentation.push(reports_data[idx].emission_alimentation)
      })
    let datas = {
      labels: labels,
      datasets: [
        {
          label: groupName[0],
          data: Logement,
          backgroundColor: color[0],
          borderColor: color[0],
          borderWidth: 1,
        },
        {
          label: groupName[1],
          data: Transport,
          backgroundColor: color[1],
          borderColor: color[1],
          borderWidth: 1,
        },
        {
          label: groupName[2],
          data: Shopping,
          backgroundColor: color[2],
          borderColor: color[2],
          borderWidth: 1,
        },
        {
          label: groupName[3],
          data: Alimentation,
          backgroundColor: color[3],
          borderColor: color[3],
          borderWidth: 1,
        },
      ],
    }
   
    setRevData(datas)
   
  }, [reports])
  const HorizontalBarChart = () => (
    <>
      {reports && data.labels.length === 0 && data.datasets[0].data.length === 0 ? (
        <WTypography variant="h6" align="center" marginTop="10rem">
          Aucune donnée
        </WTypography>
      ) : reports.length !== 0 ? (
        <Bar data={data} height="140%" options={optionsbar} />
      ) : (
        <WTypography variant="h6" align="center" marginTop="10rem">
          Aucune donnée
        </WTypography>
      )}
    </>
  )
  return (
    <div className="barg-chart" height="80%">
      <HorizontalBarChart />
    </div>
  )
}

export default GEmissionBarChart
